import { useQuery } from "@tanstack/react-query";

import { CUSTOMER_QUERY_KEYS } from "common/constants";

import { get } from "../helpers/HTTP";

import type { DetailedWorkspace } from "../types";

async function getWorkspaceRequest(
  workspaceId: string,
): Promise<DetailedWorkspace> {
  return (await get(`workspaces/${workspaceId}`)).workspace;
}

export default function useWorkspaceDetails(workspaceId: string) {
  const {
    data: workspace,
    isLoading: isLoadingWorkspace,
    error: workspaceError,
    refetch: refetchWorkspace,
  } = useQuery({
    queryKey: CUSTOMER_QUERY_KEYS.workspaces.details(workspaceId),
    queryFn: () => getWorkspaceRequest(workspaceId),
  });

  return {
    workspace,
    workspaceError,
    isLoadingWorkspace,
    refetchWorkspace,
  };
}
